import { Button, Link, styled, TableCell, TableRow } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";


export const ButtonStyles = styled(Button)(() => ({
    fontFamily: 'Roboto, sans-serif',
    textTransform: "none",
    margin: "4px",
    border: "none",
    padding: "4px 35px",
    borderRadius: 20,
    backgroundColor: "#638dff",
    color: "#FFFFFF",
    fontSize: 12,
    boxShadow: "none",
    "&:hover": {
        backgroundColor: "#4c71d6",
    },
    "&:focus": {
        boxShadow: "0 0 6px 0 #638dff !important",
    },
    "&:disabled": {
        backgroundColor: "#aeb8d6",
        color: "#e8ecf8",
    },
}));


const baseCellStyles = {
    fontSize: 14,
    color: "#44485A",
    fontFamily: 'Roboto, sans-serif',
    borderBottom: 'none !important',
};

const baseLinkStyles = {
    fontSize: 14,
    color: '#638DFF !important',
    textDecoration: 'none',
};

const baseRowStyles = (props) => ({
    backgroundColor: '#ffffff',
    whiteSpace: 'break-spaces',
    '&:nth-of-type(odd)': {
        backgroundColor: props.isSectionId ? '#f7f7f7' : '#f4f7fb',
    },
});

const offlineRowStyles = {
    backgroundColor: '#FFF1E2',
    '&:nth-of-type(odd)': {
        backgroundColor: '#F9EBDC',
    },
};

export const StyledTableCell = styled(TableCell)(baseCellStyles);

export const StyledLink = styled(Link)(() => ({
    ...baseLinkStyles,
    cursor: 'pointer'
    // Uncomment if needed
    // ...(userDomain === DOMAIN_ONSHIP && { fontFamily: "Figtree-Regular" }),
}));

export const StyledSyncIcon = styled(SyncIcon)(({ theme }) => ({
    fontSize: 20,
    backgroundColor: "white",
    borderRadius: 20,
    color: "#e5743b",
    border: "1px solid",
}));


export const StyledSpan = styled("span")(({ theme }) => ({
    width: "1%",
    whiteSpace: "nowrap",
}));


export const StyledTableRow = styled(TableRow, {
    shouldForwardProp: (prop) => !["isoffline", "isSectionId"].includes(prop),
})((props) => ({
    ...baseRowStyles(props),
    ...(props.isoffline !== "true" && offlineRowStyles),
}));

const MainButton = styled(Button)(() => ({
    border: 'none',
    padding: '7px 45px',
    borderRadius: 20,
    textTransform: 'inherit',
    '&:hover': { border: 'none' },
}));

export const CancelButton = styled(MainButton)(() => ({
    backgroundColor: '#e0e8ff',
    color: '#638dff',
    border: 'none',
    fontFamily: 'SF Pro Text Bold',
    fontSize: 14,
    boxShadow: 'none',
    '&:hover': { backgroundColor: '#eef2ff' },
    '&:focus': {
        boxShadow: '0 0 6px 0 rgba(99, 141, 255, 0.6)',
        backgroundColor: '#eef2ff',
    },
    '&:disabled': {
        backgroundColor: '#e8ecf8',
        color: '#aeb8d6',
        border: 'none',
    },
}));

export const ConfirmButton = styled(MainButton)(() => ({
    backgroundColor: '#638dff',
    color: '#FFFFFF',
    fontFamily: 'SF Pro Text Bold',
    fontSize: 14,
    boxShadow: 'none',
    '&:hover': { backgroundColor: '#4c71d6' },
    '&:focus': { boxShadow: '0 0 6px 0 #638dff !important' },
    '&:disabled': {
        backgroundColor: '#aeb8d6',
        color: '#e8ecf8',
    },
}));